module.exports = __webpack_public_path__ + "static/banner-ea38f4c618c6b2d11707d168d66e7ec4.png";